import React, {
    createContext, useContext, useState, useMemo,
} from 'react';

const UserContext = createContext({});

function UserProvider({ children }) {
    const [user, setUser] = useState(null);

    const permissions = useMemo(() => {
        if (!user) {
            return {
                endpoints: [],
                projects: [],
            };
        }

        const endpoints = [];
        Object.entries(user.permissions.endpoints).forEach(([key, value]) => {
            if (value === 3) {
                endpoints.push(key);
            }
        });

        return {
            endpoints,
            projects: user.permissions.projects,
        };
    }, [user]);

    const userContextValue = useMemo(() => ({ user, permissions, setUser }), [user, permissions]);

    return <UserContext.Provider value={userContextValue}>{children}</UserContext.Provider>;
}

function withUser(Component) {
    return function (props) {
        return (
            <UserProvider>
                <Component {...props} />
            </UserProvider>
        );
    };
}

function useUser() {
    const context = useContext(UserContext);

    if (context === undefined) {
        throw new Error('useUser must be used within a UserProvider');
    }

    return context;
}

export {
    UserProvider, useUser, withUser, UserContext,
};
